module.exports = __webpack_public_path__ + "img/banner.94a92cb7.png";